export enum EDealTypeEx {
  /** Купить **/
  Buy = 'buy',
  /** Сдать **/
  Rent = 'rent',
  /** Продать **/
  Sale = 'sale',
  /** Продать, чтобы купить **/
  SellToBuy = 'sellToBuy',
  /** Снять **/
  Tenant = 'tenant',
}
